export default __webpack_public_path__ + "static/media/render1.4964bb2a.webp";